// De kolombreedtes van een matrixvraag.
//
// WAAROM DIT BESTAAT. De kolommen kregen allemaal `minmax(0, 1fr)` — óók de
// kolom met de stelling erin. Op een kaart van 760 pixels is dat ongeveer 126
// pixels voor een hele zin, en `minmax(0, …)` staat toe dat een kolom smaller
// wordt dan zijn inhoud. Gevolg: de stelling liep zichtbaar over de eerste
// bolletjeskolom heen. Geen fout, geen waarschuwing — alleen tekst die door
// een bolletje heen loopt.
//
// De stelling is een zin en verdient dus meer ruimte dan een bolletje. De
// ondergrens houdt hem leesbaar op een smal scherm; de `fr` laat hem meegroeien
// zodra er ruimte is.
//
// @param {number} [columnCount] - Aantal antwoordkolommen (de schaal)
// @param {boolean} [bipolar] - Staat er rechts een tegenpool? Die is ook een zin.
// @returns {string} Waarde voor `grid-template-columns`

const STELLING = 'minmax(190px, 2.4fr)'

const matrixGridTemplate = (columnCount, bipolar = false) => {
    const kolommen = Number(columnCount) || 0
    const schaal = `repeat(${kolommen}, minmax(0, 1fr))`

    return [STELLING, schaal, bipolar ? STELLING : null].filter(Boolean).join(' ')
}

export default matrixGridTemplate
